module.exports = __webpack_public_path__ + "static/media/user_top_navbar_icon.f24d45ff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user_top_navbar_icon.svg
// module id = 222
// module chunks = 1